import { z } from "zod";

export const languageCodeSchema = z.enum(["it", "en"]);

export const multiLanguageStringSchema = z.array(z.object({
  lang: languageCodeSchema,
  string: z.string(),
}));
